import React from 'react';
import {View, StyleSheet, ViewStyle, TextStyle, TouchableOpacity, Text} from 'react-native';
import {Colors, disabledOpacity, onPressOpacity, Sizes, TextStyles} from '../';
import {ComponentProps} from './ComponentProps';

interface LabelButtonProps extends ComponentProps {
  text: string;
  onPress: () => void;
  color?: string;
  // grays out button if false. (by default: true)
  isEnabled?: boolean;
  iconLeft?: JSX.Element;
  containerStyle?: ViewStyle;
  testID?: string;
}

export const LabelButton = (props: LabelButtonProps) => {
  const isEnabled = props.isEnabled ?? true;
  let containerStyle: ViewStyle[] = [props.containerStyle ?? {}, {opacity: isEnabled ? 1 : disabledOpacity}];
  let textStyle: TextStyle[] = [TextStyles.textMediumS, {color: props.color ?? Colors.brandBase}];
  return (
    <View style={containerStyle}>
      <TouchableOpacity
        style={styles.container}
        activeOpacity={isEnabled ? onPressOpacity : 1}
        onPress={isEnabled ? props.onPress : undefined}
        testID={props.testID}>
        {props.iconLeft && <View style={styles.iconLeft}>{props.iconLeft}</View>}
        <Text style={textStyle}>{props.text}</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  iconLeft: {
    marginHorizontal: Sizes.s,
  },
});
